import { MerchantId, SetHeaderService } from "@/helper/userHelper";
import { PositionModel } from "@/model/position/positionModel";
import { PositionTableViewModel } from "@/model/position/positionTableViewModel";
import service from "../baseHttpService";

class PositionService {
  DoCreatePosition(position: PositionModel) {
    const _input = {
      merchantId: MerchantId(),
      data: position,
    };
    return service.peakPayrollAPI.post("/api/Position/CreatePosition", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoUpdatePosition(position: PositionModel) {
    const _input = {
      merchantId: MerchantId(),
      data: position,
    };
    return service.peakPayrollAPI.post("/api/Position/UpdatePosition", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoUpdatePositionDeleted(positionId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: positionId,
    };
    return service.peakPayrollAPI
      .post("/api/Position/UpdatePositionDeleted", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoUpdatePositionArchived(positionDetail: any) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        positionId: positionDetail.id,
        isArchived: positionDetail.isArchived,
      },
    };
    return service.peakPayrollAPI
      .post("/api/Position/UpdatePositionArchived", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }

  DoGetPositionTable(departmentId: number, positionTableViewModel: PositionTableViewModel) {
    const _input = {
      merchantId: MerchantId(),
      data: {
        departmentId: departmentId,
        tableView: positionTableViewModel,
      },
    };

    return service.peakPayrollAPI.post("/api/Position/GetPositionTable", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoGetPositionDetail(positionId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: positionId,
    };

    return service.peakPayrollAPI.post("/api/Position/GetPositionDetail", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }

  DoGetPositionList(departmentId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: departmentId,
    };

    return service.peakPayrollAPI.post("/api/Position/GetPositionList", _input, SetHeaderService()).then((res) => {
      return res;
    });
  }
  DoGetPositionSuggestionCode(departmentId: number) {
    const _input = {
      merchantId: MerchantId(),
      data: departmentId,
    };
    return service.peakPayrollAPI
      .post("/api/Position/GetPositionSuggestionCode", _input, SetHeaderService())
      .then((res) => {
        return res;
      });
  }
}

export default new PositionService();
